import * as React from 'react'
import BaseIcon from '../../BaseIcon'

export default class AuditIcon extends BaseIcon {
  getChildren = () => [ <path fill={ this.getColor() }
                              d='M12,15H3a1,1,0,0,1-1-1V2H5A1,1,0,0,1,6,1H9a1,1,0,0,1,1,1h3V14A1,1,0,0,1,12,15ZM3,4V14h9V4H3Zm1,8h7v1H4V12Zm0-2h7v1H4V10ZM3.988,6.055L6.082,7.48,7.443,5.01,8.909,7.48,11,6.055,10.181,9H4.838Z'/> ]
  getViewBox = () => '0 0 16 16'
}
